/*
 * @Author: Teemo Ding
 * @Date: 2021-05-26 17:49:06
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-08 10:22:22
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/collection/index.ts
 */
import { get, post, remove } from 'src/tools/server';

const getCollectionList = (data, params): Promise<any> => {
  return post<any>(`/portal/salesChannel/collections`, data, params || {});
};

const checkCollectionUnique = ({
  salesChannelUuid,
  uuid,
  queryContent,
}): Promise<any> => {
  return post<any>(
    `/portal/salesChannel/collection/checkName`,
    {
      salesChannelUuid,
      uuid,
      queryContent,
    },
    {},
  );
};

const addCollection = (body, params): Promise<any> => {
  return post<any>(`/portal/salesChannel/collection/save`, body, params || {});
};

const deleteCollection = (salesChannelCollectionUuid): Promise<any> => {
  return remove<any>(
    `/portal/salesChannel/collection/${salesChannelCollectionUuid}`,
    {},
  );
};
const copyProducts = (body): Promise<any> => {
  return post<any>(`/portal/salesChannel/collection/copyProducts`, body, {});
};

const getCollectionDetail = (
  salesChannelCollectionUuid,
  params,
): Promise<any> => {
  return get<any>(
    `/portal/salesChannel/collection/${salesChannelCollectionUuid}`,
    params || {},
  );
};
const duplicateCollection = (SaleChannelCollectionUuid): Promise<any> => {
  return post<any>(
    `/portal/salesChannel/collection/${SaleChannelCollectionUuid}/duplicate`,
    {},
    {},
  );
};

export {
  getCollectionList,
  checkCollectionUnique,
  addCollection,
  deleteCollection,
  copyProducts,
  getCollectionDetail,
  duplicateCollection,
};
